import React from 'react';
import dict from 'config/dictionary';
import externalLinks from 'config/externalLinks';
import { path, pathOr } from 'ramda';
import { interpolateMany } from './interpolate';

const userFriendlyStatuses = [422, 404, 500];

export const TILLO_VOUCHER_TYPES = ['tillo', 'wegift'];

export const isTilloVoucher = voucherType =>
  TILLO_VOUCHER_TYPES.includes(voucherType);

const supportLink = (
  <a href={externalLinks.email.support.url}>
    {externalLinks.email.support.label}
  </a>
);

export const fallbackError = (itemType = 'item', action = 'redeeming') =>
  dict.unknownAPIError.map((text, index) => (
    <React.Fragment key={index}>
      {interpolateMany(text, [
        ['[item_type]', <>{itemType}</>],
        ['[action]', <>{action}</>],
        ['[support_email]', supportLink]
      ])}
      {index < dict.unknownAPIError.length - 1 && (
        <>
          <br />
          <br />
        </>
      )}
    </React.Fragment>
  ));

const renderErrorLines = (lines, replacements) =>
  lines.map((text, index) => (
    <React.Fragment key={index}>
      {interpolateMany(text, replacements)}
      {index < lines.length - 1 && (
        <>
          <br />
          <br />
        </>
      )}
    </React.Fragment>
  ));

export const tilloVoucherError = brandName => {
  const possessive = brandName ? `${brandName}'s` : `this brand's`;
  return renderErrorLines(dict.tilloVoucherError, [
    ['[brand_name]', <>{possessive}</>],
    ['[support_email]', supportLink]
  ]);
};

export const voucherRedemptionError = () =>
  renderErrorLines(dict.voucherRedemptionError, [
    ['[support_email]', supportLink]
  ]);

/**
 * @deprecated This will be removed at some point
 * @param {Object} err
 */
export const translateAPIError = err => {
  let status = Number(path(['response', 'status'], err));
  let message = userFriendlyStatuses.includes(status)
    ? pathOr(
        path(['response', 'data', 'message'], err),
        ['response', 'data', 'error'],
        err
      )
    : null;
  return message || fallbackError();
};
